<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <g :fill="iconColor">
      <path
        d="M5.66406 3.15625C5.58594 3.46875 5.35156 3.625 5.07812 3.625H4.375C4.02344 3.625 3.75 3.9375 3.75 4.25V5.5H7.5H11.25V4.25C11.25 3.9375 10.9375 3.625 10.625 3.625H9.92188C9.60938 3.625 9.375 3.46875 9.29688 3.15625C9.10156 2.375 8.35938 1.75 7.5 1.75C6.60156 1.75 5.85938 2.375 5.66406 3.15625ZM7.5 0.5C8.75 0.5 9.88281 1.28125 10.3516 2.375H10.625C11.4062 2.375 12.1094 2.92188 12.3828 3.625H12.5C13.8672 3.625 15 4.75781 15 6.125V18C15 19.4062 13.8672 20.5 12.5 20.5H2.5C1.09375 20.5 0 19.4062 0 18V6.125C0 4.75781 1.09375 3.625 2.5 3.625H2.57812C2.85156 2.92188 3.55469 2.375 4.375 2.375H4.60938C5.11719 1.28125 6.21094 0.5 7.5 0.5ZM12.5 4.875V5.5C12.5 6.20312 11.9141 6.75 11.25 6.75H7.5H3.75C3.04688 6.75 2.5 6.20312 2.5 5.5V4.875C1.79688 4.875 1.25 5.46094 1.25 6.125V18C1.25 18.7031 1.79688 19.25 2.5 19.25H12.5C13.1641 19.25 13.75 18.7031 13.75 18V6.125C13.75 5.46094 13.1641 4.875 12.5 4.875ZM8.125 3.625C8.125 3.97656 7.8125 4.25 7.5 4.25C7.14844 4.25 6.875 3.97656 6.875 3.625C6.875 3.3125 7.14844 3 7.5 3C7.8125 3 8.125 3.3125 8.125 3.625ZM6.67969 9.71875L4.80469 11.5938C4.57031 11.8281 4.14062 11.8281 3.90625 11.5938L2.96875 10.6562C2.73438 10.4219 2.73438 9.99219 2.96875 9.75781C3.20312 9.52344 3.63281 9.52344 3.86719 9.75781L4.375 10.2656L5.78125 8.82031C6.01562 8.58594 6.44531 8.58594 6.67969 8.82031C6.91406 9.05469 6.91406 9.48438 6.67969 9.71875ZM7.5 11.125C7.5 10.8125 7.77344 10.5 8.125 10.5H10.625C10.9375 10.5 11.25 10.8125 11.25 11.125C11.25 11.4766 10.9375 11.75 10.625 11.75H8.125C7.77344 11.75 7.5 11.4766 7.5 11.125ZM6.25 14.875C6.25 14.5625 6.52344 14.25 6.875 14.25H10.625C10.9375 14.25 11.25 14.5625 11.25 14.875C11.25 15.2266 10.9375 15.5 10.625 15.5H6.875C6.52344 15.5 6.25 15.2266 6.25 14.875ZM4.375 15.8125C3.82812 15.8125 3.4375 15.4219 3.4375 14.875C3.4375 14.3672 3.82812 13.9375 4.375 13.9375C4.88281 13.9375 5.3125 14.3672 5.3125 14.875C5.3125 15.4219 4.88281 15.8125 4.375 15.8125Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
